import React from 'react';
import Scene from '../components/three/Scene';
import Cursor from '../components/immersive/Cursor';
import Nav from '../components/immersive/Nav';
import Hero from '../components/immersive/Hero';
import Marquee from '../components/immersive/Marquee';
import About from '../components/immersive/About';
import Experience from '../components/immersive/Experience';
import Skills from '../components/immersive/Skills';
import Contact from '../components/immersive/Contact';
import { portfolioData } from '../data/portfolioData';
import '../styles/theme.css';

export default function ImmersivePortfolio() {
  const year = 2026; // build-year; keep static so the page is deterministic

  return (
    <>
      <div className="grain" aria-hidden="true" />
      <Cursor />
      <Scene />

      <div className="app-shell">
        <Nav />
        <Hero />
        <Marquee />
        <About />
        <Experience />
        <Skills />
        <Contact />

        <footer className="footer">
          <span>© {year} {portfolioData.hero.firstName} {portfolioData.hero.lastName}</span>
          <span>Built with React · Three.js · Framer Motion</span>
          <a href="#top">Back to top ↑</a>
        </footer>
      </div>
    </>
  );
}
